<i class="betslip-pick-remove {{ removeButtonClass }}" (click)="clickRemovePick()"></i>
